import { render, staticRenderFns } from "./CpdScoreText.vue?vue&type=template&id=3703f50a"
import script from "./CpdScoreText.js?vue&type=script&lang=js&external"
export * from "./CpdScoreText.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports